__turbopack_context__.v({
  "main": "Container-module__5IB63q__main",
  "narrow": "Container-module__5IB63q__narrow",
  "wide": "Container-module__5IB63q__wide",
});
